import React, { Component } from "react";
import PropTypes from "prop-types";
import pick from "lodash.pick";
import params from "../utils/url_params";
import validation from "../utils/validation";

function Step(WrappedComponent, inputs = {}) {
	class Step extends Component {
		constructor(props) {
			super(props);

			this.state = {
				inputs: {
					...inputs,
					...pick(params, Object.keys(inputs)),
				},
				errors: false,
			};

			this.submitHandler = this.submitHandler.bind(this);
			this.changeHandler = this.changeHandler.bind(this);
			this.handleQueryCheck = this.handleQueryCheck.bind(this);
		}

		componentWillMount() {
			if (this.props.active) {
				this.handleQueryCheck();
			}
		}

		componentWillReceiveProps(nextProps) {
			if (nextProps.seen && !this.props.seen && nextProps.active) {
				this.handleQueryCheck();
			}
		}

		// This is called when the component becomes active to check when if all the relevant data has been
		// provided by the query string
		handleQueryCheck() {
			const invalidInputs = validation(this.state.inputs);
			if (!invalidInputs) {
				this.submitHandler();
			}
		}

		submitHandler(e) {
			if (e) {
				e.preventDefault();
			}

			if (this.props.processing) {
				return;
			}

			const validateInputs = validation(this.state.inputs);

			if (validateInputs) {
				Object.keys(validateInputs).forEach(
					x => (validateInputs[x] = validateInputs[x][0])
				);
				this.setState({
					errors: validateInputs,
				});

				return;
			}

			this.props.onComplete(this.state.inputs);
		}

		changeHandler(e) {
			this.setState({
				inputs: {
					...this.state.inputs,
					[e.target.name]: e.target.value,
				},
				errors: {
					...this.state.errors,
					[e.target.name]: null,
				},
			});
		}

		render() {
			const { active, ...props } = this.props;
			const { inputs, errors } = this.state;
			const newProps = {
				changeHandler: this.changeHandler,
				submitHandler: this.submitHandler,
				inputs,
				errors,
			};
			return active ? <WrappedComponent {...props} {...newProps} /> : null;
		}
	}

	Step.propTypes = {
		active: PropTypes.bool,
		seen: PropTypes.bool,
		onComplete: PropTypes.func,
		processing: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	};

	Step.displayName = `Step(${WrappedComponent.displayName ||
		WrappedComponent.name ||
		"Component"})`;

	return Step;
}

export default Step;



// WEBPACK FOOTER //
// ./src/components/Step.js